export const circle = require('./cercle.png');
export const circle_footer_left = require('./cercle_footer_gauche.png');
export const circle_footer_right = require('./cercle_footer_droite.png');
export const tro_circle_home_page = require('./tri_cercle_accueil.png');
export const circle_slogan = require('./Cercle_baseline.png');
export const circle_navbar = require('./cercle_navbar.png');
